import store from '@/store'

const authorizationErroCodes = [
  401,
  403,
];

export async function requestWrapper(requestCallback) {
  try {
    const response = await requestCallback();
  
    if (authorizationErroCodes.includes(response.status)) {
      await store.dispatch('logoutUser');
    }

    let responseBody;
    
    try {
       responseBody = await response.json();
    }
    catch {
      return {
        success: response.ok,
        message: "Sem conteúdo"
      }
    }
    
    const formattedResponseBody = response.ok ? {
      data: responseBody
    } : {
      errors: [],
      ...responseBody
    };

    return {
      success: response.ok,
      ...formattedResponseBody,
    }
  }
  catch (err) {
    return {
      success: false,
      message: "Erro de rede",
      errors: [err.message],
    }
  }
}
